import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-2-line text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50">
                韩国伦理文化研究
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              深度解析韩国伦理文化与价值观，涵盖儒家传统、现代伦理、家庭社会、职场规范与影视文化中的伦理议题。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-400 hover:text-foreground-100 text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-foreground-400 hover:text-foreground-100 text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-foreground-400 hover:text-foreground-100 text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  品牌声誉
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-foreground-400 hover:text-foreground-100 text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              联系方式
            </h4>
            <ul className="flex flex-col gap-2.5 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                contact@korea-ethics.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                韩国首尔特别市钟路区
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                korea_ethics_culture
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 韩国伦理文化研究 版权所有
          </p>
          <div className="flex items-center gap-5">
            <a
              href="#"
              className="text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer"
              aria-label="微信"
              rel="nofollow"
            >
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer"
              aria-label="知乎"
              rel="nofollow"
            >
              <i className="ri-question-answer-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}